export function getVisitorDisplayName(identifier, visitorId) {
  return identifier || `Visitor #${visitorId}`;
}
